import { AppBundle } from 'api/optimalprint-sdk.d';
import { AppDispatch, Store } from 'store';
import getPrice from 'store/price/selector/getPrice';
import gtmProductViewEvent from 'utils/gtm/gtmProductViewEvent';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import getCategoryId from '../selector/getCategoryId';

const sendGtmPersonalisedProductViewOperation =
  (
    abstractProduct: AppBundle.Api.Entity.App.V1.IAbstractProduct,
    product: AppBundle.Api.Entity.App.V1.AbstractProduct.IProductItem,
  ) =>
  (dispatch: AppDispatch, getState: () => Store) => {
    const store = getState();
    const productId = product?.productId;
    const categoryId = getCategoryId(store);
    if (!productId || !categoryId) return;

    const price = getPrice(store, categoryId, productId, 1);
    if (!price) return;

    const gtmProductData = {
      brand: 'Optimalprint',
      category: abstractProduct?.slug,
      id: abstractProduct?.initialProduct.productId,
      list: 'Category Page',
      marketing_material: 'not included',
      name: product?.name,
      price: price.p,
      designIdEncLocale: product?.sku,
    };
    gtmSendEvent(gtmProductViewEvent(gtmProductData));
  };

export default sendGtmPersonalisedProductViewOperation;
